import api from './api';
import { AuthResponse, LoginRequest, RegisterRequest, User } from '../types';

export const authService = {
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  async register(userData: RegisterRequest): Promise<AuthResponse> {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  async verifyToken(): Promise<{ valid: boolean; user: User }> {
    const response = await api.get('/auth/verify');
    return response.data;
  },

  async refreshToken(token: string): Promise<{ token: string }> {
    const response = await api.post('/auth/refresh', { token });
    return response.data;
  },

  logout() {
    localStorage.removeItem('token');
  },

  setToken(token: string) {
    localStorage.setItem('token', token);
  },

  getToken(): string | null {
    return localStorage.getItem('token');
  }
};
